import Config from '@/config/config'

function checkImgSrc(img) {
  if(!img.match(Config.APIURL)) {
    return Config.APIURL + img;
  } else {
    return img;
  }
}

export default {
  checkImgSrc
}



// WEBPACK FOOTER //
// ./src/model/imgLoad.js